const items = [
  "5,000+ clinics across the USA",
  "Book appointments online",
  "First-visit discount",
  "Easy online booking",
  "Nationwide network",
];

const Star = () => (
  <svg viewBox="0 0 24 24" className="h-3 w-3 shrink-0 text-brand-bright" fill="currentColor" aria-hidden="true">
    <path d="M12 0c.9 6.6 5.4 11.1 12 12-6.6.9-11.1 5.4-12 12-.9-6.6-5.4-11.1-12-12C6.6 11.1 11.1 6.6 12 0z" />
  </svg>
);

const Row = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {items.map((t) => (
      <span key={t} className="flex items-center">
        <span className="whitespace-nowrap px-7 font-display text-lg italic text-brand-deep/80">{t}</span>
        <Star />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative overflow-hidden py-8" data-testid="editorial-marquee">
    <div className="-ml-[2%] w-[104%] -rotate-1 overflow-hidden border-y border-line bg-mint-soft/70 py-5">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        <Row />
        <Row hidden />
      </div>
    </div>
  </div>
);
